import {timeUtil} from './util.js'

import enumStore from './EnumStore.js'

let formatter = {}

formatter.formatterDate = function (value, cFormat) { // 时间格式化
  if (value === undefined || value === null) {
    return null
  }
  if (cFormat) {
    return timeUtil.parseTime(value, cFormat)
  }
  return timeUtil.parseTime(value, '{y}-{m}-{d} {h}:{i}:{s}')
}

const a = {
  'fGuideStatus': '导标状态',
  'fAttachmentType': '附件类型',
  'fCompanyLicense': '公私牌',
  'fLCVType': '乘用车类型',
  'fGPSStatus': 'GPS状态',
  'fLoanStatus': '放款状态',
  'fRecordStatus': '抵押状态',
  'fApplyStatus': '流程状态',
  'fAssure': '是否有担保人',
  'fCancel': '取消类型',
  'fPass': '通过类型',
  'fReject': '拒绝申请类型',
  'fHouseOwnerId': '住房所有权',
  'fApproveAnnexType': '申请附件类型',
  'fBeforeLoanAnnexType': '贷前附件类型',
  'fAfterLoanAnnexType': '贷后附件类型',
  'fMarriageType': '婚姻状况',
  'fEducationId': '学历',
  'fIndustryId': '从事行业',
  'fPositionId': '职位',
  'fDriverTypeId': '准驾车型',
  'fResidenceNatureId': '户口性质',
  'fUnitKindId': '工作单位性质',
  'fIDType': '证件类型',
  'fProvince': '省份',
  'fCity': '市',
  'fDistrict': '区',
  'fUploadFileType': '上传附件类型',
  'fGpsInstallStatus': 'GPS安装类型',
  'fManualAuditCode': '人工审核状态',
  'fGpsInstallState': 'GPS安装状态',
  'fGpsApprovalStatus': 'GPS审批状态'
}

for (let key in a) {
  formatter[key] = function (value) {
    if (value || value === 0) {
      return enumStore.state[a[key]][value]
    }
  }
}

export {
  formatter
}



// WEBPACK FOOTER //
// ./src/assets/js/format.js